module.exports = __webpack_public_path__ + "static/img/qrcode-white.5517204.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qrcode-white.jpg
// module id = fugm
// module chunks = 1